import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ListItemType } from 'shell/models/item-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface CivicStateProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const CivicStateComponent = ({
  disabled,
  onChange,
  value,
}: CivicStateProps): React.ReactElement => {
  const {
    data,
    error,
    get: getCivicStates,
  } = useHttpFetch<HttpResponseList<ListItemType>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/civico/tipo/stato`,
    {
      data: {
        payload: {
          list: [],
        },
      },
    }
  );

  const civicStates: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((civicState) => ({
      id: civicState.key,
      value: civicState.descrizione,
    }));
  }, [data, error]);

  useEffect(() => {
    getCivicStates();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="civicState-label" disabled={disabled}>
        Stato Civico
      </InputLabel>
      <PmiSelect
        labelId="civicState-label"
        id="civicState"
        name="civicState"
        value={value}
        label="Stato Civico"
        onChange={onChange}
        disabled={disabled}
      >
        <MenuItem value="">&nbsp;</MenuItem>
        {civicStates.map((civicState: ItemVM) => (
          <MenuItem key={civicState.id} value={civicState.id}>
            {civicState.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CivicStateComponent.displayName = 'Civic state component';

const CivicState = memo(CivicStateComponent);

export default CivicState as typeof CivicStateComponent;
